import { getDate } from '../../../../../utils/dateUtils';
import { numberToWords } from '../../../../../utils/helper';
import CreditNoteTable from '../createCreditNote/creditNoteTable';

function SalesCreditNotePdfView({
	creditNoteDetails,
	setIsDrawerOpen,
	setDrawerType,
	setIsSalesDrawerOpen,
	setPrId,
}) {
	const {
		customer,
		credit_note_number,
		date,
		organisation,
		total_credit_amount,
		notes,
		total_paid_amount,
	} = creditNoteDetails || {};

	return (
		<div className="invoice-container">
			<div className="invoice-header">
				<div>
					<h2 style={{ fontSize: '22px', fontWeight: 'bold', color: '#0F1C35' }}>
						{organisation?.organisation_name}
					</h2>
					<div style={{ marginTop: '15px', color: '#555B67' }}>
						<p>{`${organisation?.address?.state?.name || 'N/A'}`}</p>
						<p>{`${organisation?.address?.country?.name || 'N/A'}`}</p>
					</div>
				</div>
				<div className="bill-status">
					<h2 style={{ fontSize: '30px', fontWeight: 'bold' }}>Credit Note</h2>
				</div>
			</div>

			<div
				style={{
					display: 'flex',
					gap: '60px',
					fontFamily: 'Arial',
					fontSize: '15px',
					color: '#000',
					border: '1px solid #ddd',
					padding: '13px',
				}}
			>
				<div style={{ display: 'flex', flexDirection: 'column', gap: '10px', color: '#555B67' }}>
					<span>#</span>
					<span>Credit Date</span>
				</div>

				<div style={{ display: 'flex', flexDirection: 'column', gap: '10px', fontWeight: 700 }}>
					<span>:{credit_note_number}</span>
					<span>:{getDate(date)}</span>
				</div>
			</div>

			<div
				style={{
					display: 'flex',
					border: '1px solid #ddd',
					padding: '13px',
					alignItems: 'center',
					justifyContent: 'space-between',
				}}
			>
				<div className="bill-to">
					<p style={{ color: '#0F1C35', fontSize: '16px', fontWeight: '600' }}>Bill To:</p>
					<h3
						style={{ fontWeight: 'bold', color: '#3B58FF', fontSize: '14px', cursor: 'pointer' }}
						onClick={() => {
							setIsSalesDrawerOpen(false);
							setDrawerType('customer');
							setIsDrawerOpen(true);
						}}
					>
						{customer?.name}
					</h3>
					<div style={{ marginTop: '15px', color: '#555B67' }}>
						<p>{`${customer?.street1 || 'N/A'}`}</p>
						<p>{`${customer?.state?.name || 'N/A'}`}</p>
						<p>{`${customer?.country?.name || 'N/A'} - ${customer?.zipcode || 'N/A'}`}</p>
					</div>
				</div>
			</div>

			{creditNoteDetails.credit_note_type !== 3 ? (
				<CreditNoteTable
					screenType="details"
					setIsSalesDrawerOpen={setIsSalesDrawerOpen}
					setIsDrawerOpen={setIsDrawerOpen}
					setPrId={setPrId}
					column={
						creditNoteDetails.credit_note_type === 1
							? ['Date Created', 'Sales Return Number', 'Amount']
							: ['PR#', 'Total Amount', 'Excess Amount']
					}
					rows={
						creditNoteDetails.credit_note_type === 1
							? creditNoteDetails?.damage_returns.map((ele) => {
									return {
										id: ele?.id,
										date: ele?.sales_return.date,
										return_number: ele?.sales_return?.return_number,
										amount: ele?.sales_return?.bill_total,
										sales_return_id: ele?.sales_return?.id,
									};
								})
							: creditNoteDetails?.excess_payments.map((data) => {
									return {
										id: data?.payment_receive?.id,
										pr_date: data?.payment_receive?.date,
										payment_received_number: data?.payment_receive?.payment_receive_number,
										totat_amount: data?.payment_receive?.cash_handed,
										excess_payment_amount: data?.excess_amount,
									};
								})
					}
					creditNoteType={creditNoteDetails.credit_note_type}
					handleDelete={() => {}}
					isDeleteIcon={false}
				/>
			) : (
				<table className="invoice-table">
					<thead>
						<tr>
							<th>ITEM & DESCRIPTION</th>
							<th style={{ textAlign: 'right' }}>ADVANCE AMOUNT</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td>
								<strong>Advanced Payment</strong>
								<br />
							</td>
							<td style={{ textAlign: 'right' }}>{creditNoteDetails?.total_credit_amount}</td>
						</tr>
					</tbody>
				</table>
			)}

			<div className="total-section">
				<div style={{ width: '270px' }}>
					<p style={{ fontSize: '14px', color: '#555B67' }}>Total In Words</p>
					<p
						style={{ fontSize: '14px', color: '#000000', fontWeight: 'bold' }}
					>{`${numberToWords(Number(total_credit_amount))}`}</p>
					<p style={{ fontSize: '14px', color: '#555B67' }}>Note</p>
					<p style={{ fontSize: '14px', color: '#000000', fontWeight: 'bold' }}>{notes || 'N/A'}</p>
				</div>
				<div
					className="totals"
					style={{
						fontSize: '14px',
						fontWeight: 'bold',
						color: '#000000',
						marginLeft: '110px',
						textAlign: 'right',
					}}
				>
					<p>Total </p>
					<p>Credit Redeem</p>
					<p>Credit Remaining</p>
				</div>
				<div style={{ color: '#555B67', textAlign: 'right' }}>
					<p style={{ fontSize: '14px' }}>
						<b>Rs.</b>
						{Number(total_credit_amount).toFixed(2)}
					</p>
					<p style={{ fontSize: '14px' }}>
						<b>Rs.</b> {Number(total_paid_amount).toFixed(2)}
					</p>
					<p style={{ fontSize: '14px' }}>
						<b>Rs.</b> {Number(Number(total_credit_amount) - Number(total_paid_amount)).toFixed(2)}
					</p>
				</div>
			</div>

			<div style={{ textAlign: 'right' }}>
				<p>Authorized Signature: __________________________</p>
			</div>
		</div>
	);
}

export default SalesCreditNotePdfView;
